if (!customElements.get("m-size-guide")) {
  customElements.define(
    "m-size-guide",
    class MSizeGuide extends HTMLElement {
      constructor() {
        super()
        this.selectors = {
          openButton: '[data-open-sizeguide]',
          content: '.m-form-ask-question',
          container: '.m-product-variant-setelle',
          formSuccess: '.form-ask__success'
        }
        this.modal = null;
        this.content = null;
      }

      connectedCallback() {
        this.contentElement = this.querySelector(this.selectors.content);
        this.container = this.closest(this.selectors.container) || document.querySelector(this.selectors.container);
        
        if (this.contentElement) {
          this.colorScheme = this.contentElement.dataset.colorScheme;
          this.content = this.contentElement.innerHTML;
          this.productId = this.dataset.productId;
          this.init();
        }
      }

      init() {
        this.showSuccessMessage();

        const button = this.querySelector(this.selectors.openButton);
        
        if (button) {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            
            if (this.modal) {
              this.modal.close();
              this.modal = null;
            }
            
            this.cleanupOrphanedOverlays();
            
            if (this.content) {
              this.modal = new MinimogTheme.Modal();
              
              const html = document.createElement("DIV");
              html.innerHTML = this.content;
              html.dataset.productId = this.productId; // Identificador único
              
              this.modal.appendChild(html);
              this.modal.setWidth('500px');
              this.modal.setSizes(`m-form-ask-question m-gradient ${this.colorScheme}`);
              
              if (this.container) {
                this.container.classList.remove('m:hidden');
              }
              
              this.modal.open();
              this.addCloseListener();
            }
          });
        }
      }
      
      cleanupOrphanedOverlays() {
        const overlays = document.querySelectorAll('.m-modal-overlay, .m-overlay, [class*="overlay"]');
        overlays.forEach(overlay => {
          const parentModal = overlay.closest('.m-modal, [class*="modal"]');
          if (!parentModal || !parentModal.classList.contains('is-open')) {
            overlay.remove();
          }
        });
        
        const modals = document.querySelectorAll('.m-modal, [class*="modal"]:not(.m-size-guide)');
        modals.forEach(modal => {
          if (!modal.classList.contains('is-open')) {
            modal.remove();
          }
        });
      }
      
      addCloseListener() {
        setTimeout(() => {
          const modalElement = document.querySelector('.m-modal.is-open, [class*="modal"].is-open');
          const closeButton = modalElement?.querySelector('[data-close-modal], .m-modal__close, [class*="close"]');
          const overlay = document.querySelector('.m-modal-overlay, .m-overlay');
          
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              if (this.modal) {
                this.modal.close();
              }
              this.modal = null;
              this.cleanupOrphanedOverlays();
            }, { once: true });
          }
          
          if (overlay) {
            overlay.addEventListener('click', () => {
              if (this.modal) {
                this.modal.close();
              }
              this.modal = null;
              this.cleanupOrphanedOverlays();
            }, { once: true });
          }
        }, 100);
      }
      
      showSuccessMessage() {
        const successMessage = this.container?.querySelector(this.selectors.formSuccess);
        if (successMessage) {
          MinimogTheme.Notification.show({
            target: document.body,
            method: 'appendChild',
            type: 'success',
            message: successMessage.dataset.message,
            delay: 2000,
            sticky: true
          })

          setTimeout(() => {
            const url = window.location.origin + window.location.pathname
            window.history.replaceState({}, document.title, url)
          }, 2500)
        }
      }
      
      disconnectedCallback() {
        if (this.modal) {
          this.modal.close();
          this.modal = null;
        }
      }
    }
  );
}